
import Swal from 'sweetalert2';
import { Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';
import mapService from './mapService';

var source = new VectorSource();
var vector = new VectorLayer({
  source: source,
  style: new Style({
    fill: new Fill({
      color: 'rgba(255, 0, 0, 0.2)'
    }),
    stroke: new Stroke({
      color: '#ff0000',
      width: 2
    }),
    image: new CircleStyle({
      radius: 7,
      fill: new Fill({
        color: '#ff0000'
      })
    })
  })
});

export function swalAlert(text, title = 'Status') {
    Swal.fire({
        title,
        html: text,
        confirmButtonColor: '#558e87',
        confirmButtonText: 'OK',
    });
}
export function showSpinner() {
  const loadingDiv = document.getElementById('loadingDiv');
  const loadingDivText = document.getElementById('loadingDivText');
  if (loadingDiv && loadingDivText) {
    loadingDiv.style.visibility = 'visible';
    loadingDivText.style.visibility = 'visible';
  }
}

export function hideSpinner() {
  const loadingDiv = document.getElementById('loadingDiv');
  const loadingDivText = document.getElementById('loadingDivText');
  if (loadingDiv && loadingDivText) {
    loadingDiv.style.visibility = 'hidden';
    loadingDivText.style.visibility = 'hidden';
  }
}


export function removeFeature(fid) {
  const feature = getFeature(String(fid));
  const source = vector?.getSource?.();
  const sel = mapService.getSelectController?.();

  if (feature && source) {
    // Fjern fra source
    source.removeFeature(feature);
    // Fjern fra seleksjon hvis den er valgt
    sel?.getFeatures?.()?.remove?.(feature);
    return;
  }

  // Hvis vi ikke fant feature: tøm seleksjonen (hvis den finnes)
  sel?.getFeatures?.()?.clear?.();
}

export function getFeature(sid) {
  var allFeatures = vector.getSource().getFeatures();
  for (var x = allFeatures.length; x-- > 0;) {
    if ((allFeatures[x].getProperties().id).toString() === sid) {
      return allFeatures[x];
    }
  }
};